import {DefaultTheme} from 'styled-components';

const theme: DefaultTheme = {
    borderRadius: '10px',
    colors: {
        shadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        purplePrimary: '#8c52ff',
        purpleSecondary: '#6041ac',
        coralPrimary: '#fe5758',
        greyPrimary: '#f2f0f0',
    },
};

export {theme};
